import Vue from 'vue'
import Router from 'vue-router'
import store from '@plat/store'
import _ from 'lodash'
import { sendHitPage, startHeartBeat } from '@plat/util/analytics'

Vue.use(Router)

const route = store.state.routeName
  .replace('expreso.platform.', '')
  .split('.')
  .map(piece => _.camelCase(piece))
  .join('/')

const routes = require('./routes/' + route).default

routes.push({
  path: '*',
  beforeEnter (to, from, next) {
    window.location = '/404'

    next(new Error('Page not found'))
  }
})

const router = new Router({
  routes
})

// Send analytics page view hit
router.afterEach((to, from) => {
  const pageUrl = window.location.href.replace(/#\/.*/, '') + '#' + to.path

  sendHitPage(pageUrl)
  startHeartBeat(pageUrl)
})

export default router
